module.exports = __webpack_public_path__ + "img/book4.70c9d335.jpg";